export function shouldUseStoredExperience({
  preferFirstRun = false,
  preferStoredExperience = false,
  firstRunCompleted = false,
  storedPreferencesAvailable = false,
} = {}) {
  if (!storedPreferencesAvailable) return false;
  if (preferStoredExperience) return true;
  return !preferFirstRun && firstRunCompleted;
}

export function isAppExperiencePath(pathname) {
  return /^\/app(?:\/|$)/.test(String(pathname || "").trim());
}
